/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 *  CopiedIcon Icon
 * @author Anuja Gaikwad
 * @file CopiedIcon.jsx
 */

import React from 'react';
import { SvgIcon } from '@mui/material';

function CopiedIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 10 9">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.34834 8.3C3.1142 8.3 2.88005 8.18292 2.70445 8.00731L0.187397 4.78771C-0.105284 4.43648 -0.0467472 3.96817 0.304469 3.67548C0.655685 3.38279 1.12397 3.44133 1.41665 3.79256L3.34834 6.25116L8.61659 0.280266C8.90927 -0.0709628 9.37756 -0.0709627 9.72877 0.16319C10.08 0.455881 10.08 0.924187 9.78731 1.27542L3.9337 8.00731C3.75809 8.18292 3.58249 8.3 3.34834 8.3Z"
        fill="#171717"
      />
    </SvgIcon>
  );
}

export default CopiedIcon;

